import { Maximize2, RotateCcw, ZoomIn, ZoomOut, Play, Pause } from 'lucide-react';

interface AvatarControlsProps {
  onResetView?: () => void;
  onZoomIn?: () => void;
  onZoomOut?: () => void;
  onToggleFullscreen?: () => void;
  onToggleRotate?: () => void;
  isRotating?: boolean;
  isFullscreen?: boolean;
}

export default function AvatarControls({
  onResetView,
  onZoomIn,
  onZoomOut,
  onToggleFullscreen,
  onToggleRotate,
  isRotating = false,
  isFullscreen = false,
}: AvatarControlsProps) {
  return (
    <div className="absolute top-4 right-0 flex flex-col gap-2 pointer-events-auto">
      <button
        onClick={onResetView}
        className="btn btn-sm btn-ghost bg-base-100/80 backdrop-blur-sm"
        aria-label="Reiniciar vista"
        title="Reiniciar vista"
      >
        <RotateCcw className="w-4 h-4" />
      </button>
      
      <button
        onClick={onToggleRotate}
        className={`btn btn-sm btn-ghost bg-base-100/80 backdrop-blur-sm ${isRotating ? 'btn-primary' : ''}`}
        aria-label={isRotating ? 'Detener rotación' : 'Iniciar rotación'}
        title={isRotating ? 'Detener rotación' : 'Iniciar rotación'}
      >
        {isRotating ? (
          <Pause className="w-4 h-4" />
        ) : (
          <Play className="w-4 h-4" />
        )}
      </button>
      
      <div className="flex flex-col gap-1">
        <button
          onClick={onZoomOut}
          className="btn btn-sm btn-ghost bg-base-100/80 backdrop-blur-sm"
          aria-label="Alejar"
          title="Alejar"
        >
          <ZoomOut className="w-4 h-4" />
        </button>
        <button
          onClick={onZoomIn}
          className="btn btn-sm btn-ghost bg-base-100/80 backdrop-blur-sm"
          aria-label="Acercar"
          title="Acercar"
        >
          <ZoomIn className="w-4 h-4" />
        </button>
      </div>
      
      <button
        onClick={onToggleFullscreen}
        className={`btn btn-sm btn-ghost bg-base-100/80 backdrop-blur-sm `}
        aria-label={isFullscreen ? 'Salir de pantalla completa' : 'Pantalla completa'}
        title={isFullscreen ? 'Salir de pantalla completa' : 'Pantalla completa'}
      >
        <Maximize2 className="w-4 h-4" />
      </button>
    </div>
  );
}